export default "__VITE_ASSET__D6bvmcrc__"